import { addSnackMessage } from '@greenkub-fronts/domain/snackbar';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const onGenerateDocument = createAsyncThunk(
  'onGenerateDocument',
  async (
    data: { value: string; projectId?: string },
    { dispatch, extra }: { dispatch: any; extra: any }
  ) => {
    /***************************************\
    Envoie vers page de génération de document-
    \***************************************/
    if (
      [
        'mandat-gestion',
        'decharge-non-conformite',
        'decharge-travaux-sans-declaration',
      ].includes(data.value)
    ) {
      window.open(
        `/signature/prepare/${data.projectId}/${data.value}`,
        '_blank'
      );
      return;
    }

    /***************************************\
    Envoie vers page de génération de document
    \***************************************/
    if (['bdc'].includes(data.value)) {
      const result = await dispatch(
        extra.apiSlice.endpoints.generateFile.initiate({
          projectId: data.projectId,
          standardSlug: data.value,
        })
      );

      if (result.data.message) {
        dispatch(addSnackMessage('negative', result.data.message));
      } else {
        window.open(URL.createObjectURL(result.data), '_blank');
      }
      return;
    }

    /***************************************\
     Sécurité avant génération de document
     \***************************************/

    const choice = window.confirm('voulez-vous vraiment générer ce document ?');
    if (!choice) return;

    /**
     * Argument
     */
    let nomDocument: string;

    /***************************************\
           GENERATION ORDRE DE SERVICE
    \***************************************/

    if (data.value === 'os') {
      nomDocument = 'Ordre de service';

      dispatch(
        addSnackMessage('positive', nomDocument + ' en cours de génération')
      );

      const result = await dispatch(
        extra.apiSlice.endpoints.generateFile.initiate({
          projectId: data.projectId,
          standardSlug: data.value,
          data: {},
        })
      );
      if ('error' in result) {
        const data = JSON.parse(await result.error.data.text());
        if (data.message) {
          dispatch(addSnackMessage('negative', data.message));
          return false;
        }
        dispatch(addSnackMessage('negative', 'Une erreur est survenue'));
        return false;
      } else {
        dispatch(
          addSnackMessage('positive', nomDocument + ' généré avec succès')
        );
      }
    }

    /***************************************\
           GENERATION ODOO DOCUMENT
    \***************************************/
    if (
      [
        'apf-odoo-1',
        'apf-odoo-2',
        'apf-odoo-3',
        'apf-odoo-4',
        'proforma',
        'ac-odoo-1',
        'ac-odoo-2',
        'ac-odoo-3',
        'ac-odoo-4',
      ].includes(data.value)
    ) {
      dispatch(
        addSnackMessage('positive', data.value + ' en cours de génération')
      );

      const result = await dispatch(
        extra.apiSlice.endpoints.generateFile.initiate({
          projectId: data.projectId,
          standardSlug: data.value,
        })
      );

      if (result.data) {
        window.open(URL.createObjectURL(result.data), '_blank');
      }
    }

    return true;
  }
);

export default onGenerateDocument;
